/**
 * @file Use debounce custom hook.
 */

import { useState, useEffect } from 'react';
import debounce from 'lodash.debounce';

/**
 * Debounces a value.
 *
 * @param {any} value - A value.
 * @param {number} wait - Delay time in milliseconds.
 * @param {Object} [opts] - Options.
 * @param {boolean} opts.leading - Specify invoking on the leading edge of the timeout.
 * @param {number} opts.maxWait - The maximum time `value` is allowed to be delayed before it's changed.
 * @param {boolean} opts.trailing - Specify invoking on the trailing edge of the timeout.
 * @returns {any[]}
 */
const useDebounce = (value, wait, opts) => {
  const [debouncedValue, setDebouncedValue] = useState(value);
  const handler = debounce(setDebouncedValue, wait, opts);

  useEffect(() => {
    handler(value);

    return () => handler.cancel();
  }, [value]);

  return [debouncedValue, handler.cancel];
};

export default useDebounce;
